class UtilsReward {
  static getElements (selector, { context = document, asArray = true } = {}) {
    const items = context.querySelectorAll(selector);
    return asArray ? Array.from(items) : items ;
  }
  static Status = Object.freeze({
    ENABLED: "enabled",
    PENDING: "pending"
  })
  static removeTrailingZeros(price) {
    const parts = price.split('.');
    if (parts.length === 2 && parts[1] === '00') {
        return parts[0];
    } 
      return price; 
  }
  static addThousandsSeparator(number,separator = ',') {
    return  number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, separator);
  }
  static calculateStepRatio(points,steps) {
    if(points < steps[0]) return 0; 
     for (let i = 1; i < steps.length; i++) {
      if (points <= steps[i]) {
        const rangeStart = steps[i - 1];
        const rangeEnd = steps[i];
        const range = rangeEnd - rangeStart;
        const pointsInRange = points - rangeStart;
        const ratio = (pointsInRange / range) + (i - 1);
        return ratio / (steps.length - 1);
      }
    }
    return 1; // If points exceed the max value, return 1 (100%)
}
}

class RewardModel{
  #customerPoints = window.loyaltylion.customer?.pointsRedeemable;  
  constructor(reward){
      this.points= reward.point_cost;
      this.discount= reward.discount_amount * 100;
      this.method= reward.method;      
      if (this.#customerPoints) {
        this.status = this.#customerPoints >= reward.point_cost ? UtilsReward.Status.ENABLED : UtilsReward.Status.PENDING;        
      }else{
        this.status = UtilsReward.Status.ENABLED;
      }
      this.refButton= null;
  }
  setRefButton(button){
    this.refButton = button;
  }
}

const selectors = {
  template:'[data-template="reward-item"]',
  rewardButton:'#loyaltylion .lion-action-button',
  rewardButton:'#loyaltylion .lion-action-button',
  rewardsList:'.rewards-list',
  lionRewardsList:'.lion-rewards-list',
  templateNode: (type)=> '[data-reward-item="'+ type + '"]',
  buttonDisabled: 'lion-action-button--disabled',
}

class RewardsList extends HTMLElement {

  constructor() {
    super();
    this.template = this.querySelector(selectors.template).content.firstElementChild;
    this.listEl = this.querySelector(selectors.rewardsList);
    this.waitForLoyaltyLion(selectors.lionRewardsList)
      .then(rewardsEl =>{
        this.lionRewardsEl = rewardsEl
        this.setupListeners();
        console.log('Initializing component for the first time.');
        this.initialize();
      });
  }

  initialize(){
    this.rewards = window.loyaltylion.program.rewards.map(reward => new RewardModel(reward));
    UtilsReward
      .getElements(selectors.rewardButton,{context:this})
      .forEach((button,index)=>this.rewards[index].setRefButton(button));
    this.renderRewards();
    this.setProgress();
    console.log(this.rewards);
  }

  setupListeners(){
    const observer = new MutationObserver(_ => {
      console.log('Updating component because changes on the original element were detected.');
      this.updateComponent();
    })
    observer.observe(this.lionRewardsEl, {
      childList: true,
      subtree: true,
    });
  }

  updateComponent(){
    this.rewards = window.loyaltylion.program.rewards.map(reward => new RewardModel(reward));
    this.setProgress();
    this.updateButtons();
    this.updateStatuses();
  }

  updateStatuses(){
    const steps = UtilsReward.getElements(selectors.templateNode('step'),{context:this});
    this.rewards.forEach((reward,i)=>this.setStepStatus(steps[i],reward.status));
  }

  updateButtons(){
    const refButtons = UtilsReward.getElements(selectors.rewardButton,{context:this.lionRewardsEl});
    const rewardButtons = UtilsReward.getElements(selectors.templateNode('button'),{context:this.listEl});
    rewardButtons.forEach((b,i)=> this.setButton(b,refButtons[i]));
  }

  setProgress(){
    const points = this.rewards.map(r=>r.points);
    const customerPoints = window.loyaltylion.customer?.pointsRedeemable;
    const progress = customerPoints ? UtilsReward.calculateStepRatio(customerPoints,points) : 1;
    this.style.setProperty('--progress-ratio',progress);
  }

  renderRewards(){
    this.rewards.forEach(reward=>{
      const itemEl = this.template.cloneNode(true);
      this.setDiscount(itemEl,reward.discount);
      this.setMethod(itemEl,reward.method);
      this.setPoints(itemEl,reward.points);
      if(reward.refButton){
        const buttonEl = itemEl.querySelector(selectors.templateNode('button'));      
        this.setButton(buttonEl,reward.refButton);
      }
      const stepEl = itemEl.querySelector(selectors.templateNode('step'));
      this.setStepStatus(stepEl,reward.status);      
      this.listEl.append(itemEl)
    })
  }

  setStepStatus(el,status){
    if(status === UtilsReward.Status.ENABLED){
      el.classList.add('enabled');
    } else{
      el.classList.remove('enabled');
    }
  }

  setDiscount(el,discount){
    const discountEl = el.querySelector(selectors.templateNode('discount'));
    const discountFormatted = Shopify.formatMoney(discount, window.money_format);
    discountEl.textContent = UtilsReward.removeTrailingZeros(discountFormatted).replace(",00", "");
    console.log("------------------ddd", UtilsReward.removeTrailingZeros(discountFormatted));
  }
  setMethod(el,method){
    const methodEl = el.querySelector(selectors.templateNode('method'));
    methodEl.textContent = method.replace('_',' ').toUpperCase();
  }
  setPoints(el,points){
    const pointsEl = el.querySelector(selectors.templateNode('points'));
    pointsEl.textContent = UtilsReward.addThousandsSeparator(points) + ' POINTS'
  }
  setButton(el,refButton){  
    el.innerHTML = refButton.innerHTML;
    el.disabled = refButton.classList.contains(selectors.buttonDisabled) ? true : false;   
     if(!el.disabled){      
      el.addEventListener('click', _ => refButton.click());
    }
  }
  waitForLoyaltyLion(selector) {
    const el = this;
    return new Promise(resolve => {
      if (el.querySelector(selector)) {
        return resolve(el.querySelector(selector));
      }
      const observer = new MutationObserver(mutations => {
        if (el.querySelector(selector)) {
          resolve(el.querySelector(selector));
          observer.disconnect();
        }
      });

      observer.observe(el, {
        childList: true,
        subtree: true
      });
    });
  }
}

customElements.define("rewards-list", RewardsList);